var _path, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93498 15.4997C9.53735 15.4997 13.2683 11.7687 13.2683 7.16634C13.2683 5.70247 12.8909 4.32675 12.228 3.13121C14.6602 1.97809 17.3801 1.33301 20.2507 1.33301C30.606 1.33301 39.0006 9.72764 39.0006 20.0829C39.0006 30.4382 30.606 38.8329 20.2507 38.8329C9.89536 38.8329 1.50073 30.4382 1.50073 20.0829C1.50073 18.3345 1.74006 16.6419 2.18774 15.0362C3.04792 15.3365 3.97239 15.4997 4.93498 15.4997Z",
    fill: "#FFCC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8045 7.94731L9.9191 6.72965C10.0091 5.77335 10.0541 5.2952 9.8905 5.09754C9.802 4.99062 9.68165 4.9251 9.553 4.9138C9.31515 4.89291 9.01645 5.23295 8.41905 5.91304C8.1101 6.26475 7.95565 6.44061 7.7833 6.46785C7.68785 6.4829 7.59055 6.4674 7.50235 6.42305C7.34325 6.34295 7.23715 6.12556 7.02495 5.69076L5.90655 3.39893C5.5056 2.57731 5.3051 2.1665 5 2.1665C4.6949 2.1665 4.4944 2.57731 4.09345 3.39893L2.97503 5.69076C2.76285 6.12556 2.65675 6.34295 2.49763 6.42305C2.40946 6.4674 2.31217 6.4829 2.21668 6.46785C2.04436 6.44061 1.88988 6.26475 1.58093 5.91304C0.983539 5.23295 0.684839 4.89291 0.446994 4.9138C0.318329 4.9251 0.197989 4.99062 0.109494 5.09754C-0.0541011 5.2952 -0.00910118 5.77335 0.0809039 6.72965L0.195499 7.94731C0.384324 9.95361 0.478739 10.9568 1.07004 11.5616C1.66135 12.1665 2.54758 12.1665 4.32005 12.1665H5.67995C7.4524 12.1665 8.33865 12.1665 8.92995 11.5616C9.52125 10.9568 9.61565 9.95361 9.8045 7.94731Z",
    fill: "#FFCC33"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9723_29510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 39,
    height: 38
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0006 20.0829C39.0006 30.4382 30.606 38.8329 20.2507 38.8329C9.89536 38.8329 1.50073 30.4382 1.50073 20.0829C1.50073 9.72764 9.89536 1.33301 20.2507 1.33301C30.606 1.33301 39.0006 9.72764 39.0006 20.0829Z",
    fill: "#FFCC33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0006 20.0829C39.0006 30.4382 30.606 38.8329 20.2507 38.8329C9.89536 38.8329 1.50073 30.4382 1.50073 20.0829C1.50073 9.72764 9.89536 1.33301 20.2507 1.33301C30.606 1.33301 39.0006 9.72764 39.0006 20.0829Z",
    stroke: "#FFD233"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9723_29510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3114 9.51514L40.7038 26.1344L23.9511 43.265L13.4312 32.6177L20.9068 23.5411L24.3114 9.51514Z",
    fill: "#FFCC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6627 27.0493H16.6182V29.6257H22.6627V27.0493Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9088 27.8174L22.116 27.4705V25.0181H17.1615V27.4705L16.3936 27.8174L16.5917 34.7537H17.1615V35.8437H22.116V34.7537H22.6858L22.9088 27.8174Z",
    fill: "#F6CCB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1619 25.0181V26.5292L22.1164 27.2971V25.0181H17.1619Z",
    fill: "#E3B9A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0546 39.5573C26.1784 35.8166 26.0298 28.9298 23.1067 27.8398L23.0076 28.2114C22.7598 29.0289 21.9176 30.9364 19.7376 30.9364C17.8053 30.9364 16.9878 29.4501 16.6658 28.5335L16.4924 27.8398C13.594 28.9298 13.3215 35.8166 13.3958 39.5573H26.0546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4509 30.5916L18.9216 31.5082H20.3832L20.8291 30.5916L19.64 29.6255L18.4509 30.5916Z",
    fill: "#96281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6375 29.6247L21.1734 31.2349L23.7745 28.1383L22.1395 27.3208L21.5202 27.8906L19.6375 29.6247Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1378 27.3208L19.6399 29.6247L18.1287 31.2349L15.5276 28.1135L17.1378 27.3208Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6543 39.5585L20.3818 30.6899H18.9202L18.6477 39.5585H20.6543Z",
    fill: "#96281B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4957 39.558C32.1241 36.7587 31.6534 34.108 31.257 31.6803C31.1827 31.1848 30.9598 30.8132 30.6625 30.4912C29.4734 29.1535 26.4511 28.9305 23.1316 27.6919C23.1316 27.6919 19.6634 38.0221 19.6634 38.0469L16.1953 27.6919C12.1573 29.203 8.56531 29.203 8.16894 31.5317C8.1194 31.8042 8.09461 32.0766 8.09461 32.3491C7.69825 34.6035 7.30189 37.0312 6.95508 39.5828L19.6634 44.0418L32.4957 39.558Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7688 28.1388L24.6697 30.4922L23.5054 31.4584L24.422 32.7218L19.6409 37.9983L22.6879 27.0488L24.7688 28.1388Z",
    fill: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.54 28.1374L14.6144 30.4908L15.8035 31.4569L14.8869 32.7203L19.6432 37.9969L16.6209 27.0474L14.54 28.1374Z",
    fill: "#4F4C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0396 18.0568L25.213 15.8768C25.213 13.028 22.4881 10.7241 19.6392 10.7241C16.7903 10.7241 14.0654 13.028 14.0654 15.8768L14.2388 18.0568C14.0901 18.1064 13.9415 18.1807 13.8176 18.2798C13.5947 18.478 13.446 18.7505 13.446 19.0725V20.1377C13.446 20.7075 13.8919 21.1534 14.4617 21.1782C14.4617 23.8784 17.7069 26.43 19.6392 26.43C21.5715 26.43 24.8167 23.8784 24.8167 21.1782C25.3864 21.1782 25.8324 20.7075 25.8324 20.1377V19.0725C25.8324 18.577 25.5103 18.1807 25.0396 18.0568Z",
    fill: "#F6CCB8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M25.0395 18.0568L25.2129 15.8768C25.2129 13.028 22.4879 10.7241 19.639 10.7241V18.0568C18.8958 19.667 18.4004 21.9709 18.4004 21.9709H19.639V26.4052C21.5713 26.4052 24.8165 23.8536 24.8165 21.1534C25.3863 21.1534 25.8322 20.6827 25.8322 20.1129V19.0477C25.8322 18.577 25.5101 18.1807 25.0395 18.0568Z",
    fill: "#E8BEAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1374 12.4085C25.1869 11.7148 24.9639 10.7487 24.419 9.33667C24.2951 9.01462 23.8492 8.94031 23.6262 9.23758C23.0069 10.0303 22.1646 9.8569 20.8022 9.3119C18.5231 8.37054 16.8385 8.9403 15.8724 9.95598C11.017 12.0121 14.2622 19.4934 14.2622 19.4934C14.2622 19.4934 14.2374 15.3316 15.9715 13.8453C16.0458 13.8701 19.514 13.9444 19.6131 13.9444C19.8608 13.9444 23.0069 13.9939 23.7996 13.7957C25.3355 14.7123 24.9887 19.4687 24.9887 19.4687C24.9887 19.4687 26.6485 15.3564 25.1374 12.4085Z",
    fill: "#3C2417"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperAdminIcon);
export default __webpack_public_path__ + "static/media/SuperAdminIcon.9b64effcd95086b168820b8a66743911.svg";
export { ForwardRef as ReactComponent };